module.exports = __webpack_public_path__ + "img/-s-1拷贝2@2x.802dfa06.png";